import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=35c6dc41&"
import script from "./Tags.vue?vue&type=script&lang=js&"
export * from "./Tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c6dc41')) {
      api.createRecord('35c6dc41', component.options)
    } else {
      api.reload('35c6dc41', component.options)
    }
    module.hot.accept("./Tags.vue?vue&type=template&id=35c6dc41&", function () {
      api.rerender('35c6dc41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Bulk/Pages/Tags.vue"
export default component.exports